import { Box, Grid } from "@mui/material";
import { graphql } from "babel-plugin-relay/macro";
import { useLazyLoadQuery } from "react-relay";
import { InternBrandStyleQuery } from "./__generated__/InternBrandStyleQuery.graphql";
import InternBrandScrapeAndSaveButton from "./InternBrandScrapeAndSaveButton";
import InternBrandStyleComponentMapping from "./component-mapping";
import InternBrandStyleFavicon from "./icon/InternBrandStyleFavicon";
import InternBrandStyleLogo from "./logo/InternBrandStyleLogo";
import InternBrandStylePalette from "./palette/InternBrandStylePalette";
import InternBrandStyleTypography from "./typography/InternBrandStyleTypography";

const query = graphql`
  query InternBrandStyleQuery($id: ID!) {
    brand(id: $id) {
      id
      ...InternBrandStylePalette_brand
      ...InternBrandStyleLogo_brand
      ...InternBrandStyleTypography_brand
      ...InternBrandStyleComponentMapping_brand
      ...InternBrandScrapeAndSaveButton_brand
      ...InternBrandStyleFavicon_brand
      internStyle {
        assets {
          type
          src
          html
          width
          height
        }
        buttons {
          backgroundColor
          borderColor
          borderRadius
          borderStyle
          borderWidth
          color
          padding
          fontFamily
          fontSize
          fontWeight
          textTransform
          textAlign
        }
        headerColorPalette {
          background
          foreground
          accentBackground
          accentForeground
        }
        footerColorPalette {
          background
          foreground
          accentBackground
          accentForeground
        }
      }
    }
  }
`;

type InternBrandStyleProps = {
  brandID: string;
};

const InternBrandStyle = ({ brandID }: InternBrandStyleProps) => {
  const data = useLazyLoadQuery<InternBrandStyleQuery>(query, {
    id: brandID,
  });

  return (
    <Box sx={{ minWidth: 0, maxWidth: "100%" }}>
      <Box mb={2}>
        <InternBrandScrapeAndSaveButton brand={data.brand} />
      </Box>

      <Grid container spacing={2} alignItems="stretch">
        <Grid item xs={12} sx={{ display: "flex", minWidth: 0 }}>
          <InternBrandStylePalette brand={data.brand} />
        </Grid>
        <Grid item xs={12} lg={6} sx={{ display: "flex", minWidth: 0 }}>
          <InternBrandStyleLogo brand={data.brand} />
        </Grid>
        <Grid item xs={12} lg={6} sx={{ display: "flex", minWidth: 0 }}>
          <InternBrandStyleTypography brand={data.brand} />
        </Grid>
        <Grid item xs={12} md={8} sx={{ display: "flex", minWidth: 0 }}>
          <InternBrandStyleComponentMapping brand={data.brand} />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          sx={{ display: "flex", minWidth: 0, alignItems: "flex-start" }}
        >
          <InternBrandStyleFavicon brand={data.brand} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default InternBrandStyle;
